import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { CarritoProvider } from './context/CarritoContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CarritoDrawer from './components/CarritoDrawer';
import ScrollToTop from './components/ScrollToTop';


const Home = lazy(() => import('./pages/Home'));
const Catalogo = lazy(() => import('./pages/Catalogo'));
const DetalleProducto = lazy(() => import('./pages/DetalleProducto'));
const Carrito = lazy(() => import('./pages/Carrito'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Login = lazy(() => import('./pages/Login'));
const Registro = lazy(() => import('./pages/Registro'));
const MiCuenta = lazy(() => import('./pages/MiCuenta'));
const PedidoExitoso = lazy(() => import('./pages/PedidoExitoso'));
const RecuperarPassword = lazy(() => import('./pages/RecuperarPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const NotFound = lazy(() => import('./pages/NotFound'));
const PoliticaPrivacidad = lazy(() => import('./pages/Politicaprivacidad'));
const TerminosCondiciones = lazy(() => import('./pages/Terminoscondiciones'));
const PoliticaDevoluciones = lazy(() => import('./pages/Politicadevoluciones'));
const LlantasPorMedida = lazy(() => import('./pages/LlantasPorMedida'));

const Spinner = () => (
  <div className="flex justify-center items-center py-20">
    <div className="w-8 h-8 border-4 border-red-700 border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CarritoProvider>
          <Router>
            <ScrollToTop />
            <div className="min-h-screen flex flex-col bg-gray-50">
              <Navbar />
              <CarritoDrawer />
              <main className="flex-1">
                <Suspense fallback={<Spinner />}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/catalogo" element={<Catalogo />} />
                    <Route path="/producto/:id" element={<DetalleProducto />} />
                    <Route path="/carrito" element={<Carrito />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/registro" element={<Registro />} />
                    <Route path="/pedido-exitoso" element={<PedidoExitoso />} />
                    <Route path="/mi-cuenta" element={<MiCuenta />} />
                    <Route path="/recuperar-password" element={<RecuperarPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/privacidad" element={<PoliticaPrivacidad />} />
                    <Route path="/terminos" element={<TerminosCondiciones />} />
                    <Route path="/devoluciones" element={<PoliticaDevoluciones />} />
                    <Route path="/llantas/:medida" element={<LlantasPorMedida />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </main>
              <Footer />
              <a href="https://wa.me/573105337348" target="_blank" rel="noreferrer"
                aria-label="Escríbenos por WhatsApp"
                className="fixed bottom-20 right-4 sm:bottom-6 sm:right-6 bg-green-500 hover:bg-green-600 text-white rounded-full p-3 shadow-lg z-40 transition-all hover:scale-110">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </a>
            </div>
          </Router>
        </CarritoProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;